import { useIsMobile } from "../../hooks/useIsMobile";
import { DesktopHeader } from "./DesktopHeader";
import { MobileHeader } from "./MobileHeader";

export type HeaderProps = {
  back?: boolean;
};

export default function Header(props: HeaderProps) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileHeader back={props.back} />;
  }

  return <DesktopHeader back={props.back} />;
}
